<template>
    <div class="dropdown mb-3">
        <a href="#" class="h6 mb-0" role="button" id="dealer-filter-dropdown-button" data-toggle="dropdown" aria-expanded="false">
          <i class="fa fa-filter"></i>
        </a>
        <div ref="dropdown" class="dropdown-menu card-filter-dropdown-menu" aria-labelledby="dealer-filter-dropdown-button">
            <div class="card border-0">
                <div class="card-header bg-transparent border-0">
                    Filter
                </div>
                <form method="get" @submit="submit" :action="action">
                    <div class="card-body">
                      <div class="form-group mb-0 mt-3">
                        <label for="last-name">Last Name</label>
                        <input type="text" id="last-name" v-model="form.last_name" name="last_name"/>
                      </div>
                      <div class="form-group mb-0 mt-3">
                        <label for="email">Email</label>
                        <input type="text" id="email" v-model="form.email" name="email"/>
                      </div>
                      <div class="form-group mb-0 mt-3">
                        <label for="phone">Phone</label>
                        <input type="text" id="phone" v-model="form.phone" name="phone"/>
                      </div>
                      <div class="form-group mb-0 mt-3">
                          <label for="dealer-id">Dealer Id</label>
                          <input type="text" id="dealer-id" v-model="form.dealer_id" name="dealer_id"/>
                      </div>
                    </div>
                    <div class="card-footer border-0 bg-transparent d-flex justify-content-between align-items-center">
                        <a v-if="!pending" @click="submit" :href="action">Clear Filters</a>
                        <div v-else></div>
                        <button class="btn btn-secondary" type="submit">Apply Filters</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>

const DEFAULT = {
    programs: [],
    enrolled: true,
    enrolled_in_challenges: null,
    dealer_id: null
}

export default {
    props: {
        params: {
            type: Object,
            default() {
                return {};
            }
        },
        action: {
            type: String
        }
    },
    data() {
        return {
            form: {...DEFAULT, ...this.params},
            pending: false
        }
    },
    methods: {
        submit() {
            this.pending = true;
        }
    }
}
</script>
